// extracted by mini-css-extract-plugin
export default {"pinContainer":"Im_Peup8bBFJPFjl7vrz","pinInfo":"d33BBuumK0JAXhyYPxWP"};